import moment from 'moment';

export default {
  // To the minute, in the local time: events and file revisions can follow each other within
  // the same day.
  dateTime(value) {
    return moment(value).format('DD/MM/YYYY HH:mm');
  },
};
